import { render, staticRenderFns } from "./ImageCard.vue?vue&type=template&id=48dee4e2&scoped=true"
import script from "./ImageCard.vue?vue&type=script&lang=js"
export * from "./ImageCard.vue?vue&type=script&lang=js"
import style0 from "./ImageCard.vue?vue&type=style&index=0&id=48dee4e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48dee4e2",
  null
  
)

export default component.exports